const pages = [
    {
        title: 'My Ideas',
        path: '/ideas',
        icon: 'icon-myideas',
        activeIcon: 'icon-myideas-active',
        isActive: false,
        isNotification: false,
        index: 1
    },
    {
        title: 'Brainstorm',
        path: '/lists',
        icon: 'icon-mylists',
        activeIcon: 'icon-mylists-active',
        isActive: false,
        isNotification: false,
        index: 2
    },
    {
        title: 'Evaluate',
        path: '/evaluate',
        icon: 'icon-evaluate',
        activeIcon: 'icon-evaluate-active',
        isActive: false,
        isNotification: false,
        index: 3
    },
    {
        title: 'Profile',
        path: '/profile',
        icon: 'icon-profile',
        activeIcon: 'icon-profile-active',
        isActive: false,
        isNotification: false,
        index: 4
    },
];

export { pages }